<template>

    <form ref="colaboradorendereco-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-4">
                <label for="cep">CEP</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="cep" placeholder="CEP" v-mask="mask_cep" v-model="model.cep" @change="buscarCep() && trocandoEstado" />
            </div>
            <div class="form-group col-md-8">
                <label for="endereco">Endereço</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="endereco" placeholder="Endereco" v-model="model.endereco" />
            </div>
            <div class="form-group col-md-4">
                <label for="numero">Número</label>
                <input type="number" class="form-control" :disabled="hasDisabled" name="numero" placeholder="Numero" v-model="model.numero" />
            </div>
            <div class="form-group col-md-4">
                <label for="complemento">Complemento</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="complemento" placeholder="Complemento" v-model="model.complemento" />
            </div>
            <div class="form-group col-md-4">
                <label for="bairro">Bairro</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="bairro" placeholder="Bairro" v-model="model.bairro" />
            </div>
            <div class="form-group col-md-8">
                <label for="municipioId">Município</label>
                <select v-if="municipioPorEstado" v-select="{ dataitem: 'Municipio', default: 'Selecione', filters: { estadoId: model.estadoId } }" v-model="model.municipioId" :disabled="hasDisabled" class="form-control" name="municipioId"></select>
            </div>
            <div class="form-group col-md-4">
                <label for="estadoId">Estado</label>
                <select v-select="{ dataitem: 'Estado', default: 'Selecione' }" @change="trocandoEstado" v-model="model.estadoId" :disabled="hasDisabled" class="form-control" name="estadoId"></select>
            </div>

        </div>

        <button v-if="!hasDisabled" type="button" class="btn btn-success float-left" @click="executeEdit(model)">
            <span>Salvar Endereço</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaboradorendereco-form-edit",
        mixins: [base],
        props: { colaboradorId: Number, hasDisabled: Boolean },
        data: () => ({

            municipioPorEstado: true,
            model: {
                cep: "",
                endereco: "",
                numero: "",
                complemento: "",
                bairro: "",
                municipioId: "",
                estadoId: "",

            },

            form: "colaboradorendereco-form-edit",

            resources: {
                edit: 'colaboradorendereco',
            },

        }),

        methods: {
            trocandoEstado: function (callback) {
                this.municipioPorEstado = false;
                setTimeout(() => {
                    this.municipioPorEstado = true;
                    if (callback) { setTimeout(() => { callback() }, 2000) }
                }, 500)
            },
            executeEdit: function (model) {
                model.colaboradorEnderecoId = this.colaboradorId;
                if (this.model.cep) this.model.cep = this.model.cep.replace(/\D+/g, '');
                if (this.formValidate() == false) return;

                new Api(this.resources.edit).post(model).then(data => {
                    this.defaultSuccessResult("Endereço salvo com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },
            buscarCep: function () {
                const _cep = this.model.cep;
                if (_cep && _cep.length == 9) {
                    new Api("log_logradouro/GetDataListCustom", "https://target-cep.azurewebsites.net/api/").get({ cep: _cep }).then(data => {
                        if (data.DataList == null || data.DataList.length < 1)
                            data.DataList = [{ bairro: "", cep: "", cidade: "", logradouro: "", uf: "", tipo: "" }];

                        var item = data.DataList[0];

                        this.model.endereco = item.tipo + " " + item.logradouro;
                        this.model.bairro = item.bairro;
                        this.model.municipioId = "";
                        this.model.estadoId = "";
                        this.model.numero = "";
                        this.model.complemento = "";




                        var _estados = document.getElementsByName("estadoId")[0].options;
                        for (let i = 0; i < _estados.length; i++) {
                            var _estado = _estados[i];
                            if (_estado.text.toLowerCase() == item.uf.toLowerCase()) this.model.estadoId = _estado.value;
                        }

                        this.trocandoEstado(() => {
                            var _municipios = document.getElementsByName("municipioId")[0].options;
                            //console.log(_municipios)
                            for (let i = 0; i < _municipios.length; i++) {
                                var _municipio = _municipios[i];
                                if (_municipio.text.toLowerCase() == item.cidade.toLowerCase()) this.model.municipioId = _municipio.value;
                            }
                        });
                    })
                }

            }
        },

        mounted() {
            new Api(this.resources.edit).get({ colaboradorEnderecoId: this.colaboradorId }).then(data => {
                if (data.data) this.model = data.data;
                else if (data.dataList && data.dataList.length == 1) this.model = data.dataList[0];
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>